// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__tO6NZ","label":"CategoryService_label__1CSmx","location":"CategoryService_location__Lc77Y"};